import _styled from "styled-components";
import { useMemo, useCallback } from 'react';
import Image from 'next/image';
import { Menu } from '@headlessui/react';
import { useFloating, offset, flip, shift, autoUpdate } from '@floating-ui/react';
import 'react-phone-number-input/style.css';
import { getCountries } from 'react-phone-number-input/input'; //@ts-expect-error - no types available

import countryNames from 'react-phone-number-input/locale/it';
import { getCountryCallingCode } from 'react-phone-number-input';
import { selectOptionsStyle, selectOptionStyle } from '../select/select.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CountriesMenu(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      favorites = _ref.favorites,
      wrapperStyle = _ref.wrapperStyle,
      dropdownPlacementConfig = _ref.dropdownPlacementConfig,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant;

  var _useFloating = useFloating({
    placement: 'bottom-start',
    middleware: [dropdownPlacementConfig ? offset({
      mainAxis: dropdownPlacementConfig === null || dropdownPlacementConfig === void 0 ? void 0 : dropdownPlacementConfig.mainAxis,
      crossAxis: dropdownPlacementConfig === null || dropdownPlacementConfig === void 0 ? void 0 : dropdownPlacementConfig.crossAxis
    }) : offset(8), flip(), shift()],
    whileElementsMounted: autoUpdate
  }),
      refs = _useFloating.refs,
      floatingStyles = _useFloating.floatingStyles;

  var handleSelection = useCallback(function (newValue) {
    onChange && onChange(newValue);
  }, [onChange]);
  var countries = useMemo(function () {
    return filterCountries(getCountries(), favorites);
  }, [favorites]);
  return /*#__PURE__*/_jsx(Wrapper, {
    twStyle: wrapperStyle,
    children: /*#__PURE__*/_jsxs(Menu, {
      children: [/*#__PURE__*/_jsxs(_StyledMenuButton, {
        ref: refs.setReference,
        children: [/*#__PURE__*/_jsx("span", {
          children: renderFlag(value)
        }), /*#__PURE__*/_jsx("span", {
          children: variant === 'phone' ? "+".concat(getCountryCallingCode(value)) : value
        })]
      }), /*#__PURE__*/_jsx(StyledMenuItems, {
        ref: refs.setFloating,
        style: floatingStyles,
        children: countries === null || countries === void 0 ? void 0 : countries.map(function (country) {
          return /*#__PURE__*/_jsx(Menu.Item, {
            children: function children(_ref2) {
              var active = _ref2.active;
              return /*#__PURE__*/_jsx(StyledMenuItem, {
                active: active,
                children: /*#__PURE__*/_jsxs(StyledButton, {
                  isActive: active,
                  isLastFavorite: !!(favorites !== null && favorites !== void 0 && favorites.includes(country)) && favorites[favorites.length - 1] === country,
                  onClick: function onClick() {
                    return handleSelection(country);
                  },
                  children: [/*#__PURE__*/_jsx("span", {
                    children: renderFlag(country)
                  }), /*#__PURE__*/_jsx("span", {
                    children: countryNames[country]
                  })]
                })
              });
            }
          }, country);
        })
      })]
    })
  });
}
export default CountriesMenu;
export var renderFlag = function renderFlag(country) {
  return /*#__PURE__*/_jsx(Image, {
    src: "https://purecatamphetamine.github.io/country-flag-icons/3x2/".concat(country, ".svg"),
    alt: "flag icon",
    height: 11,
    width: 16
  });
};

var filterCountries = function filterCountries(countries, favorites) {
  if (!favorites || favorites.length === 0) return countries;
  countries = countries.filter(function (country) {
    return !favorites.includes(country);
  });

  for (var i = favorites.length - 1; i >= 0; i--) {
    countries.unshift(favorites[i]);
  }

  return countries;
};

var Wrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "countries-menu__Wrapper",
  componentId: "sc-1239cyb-0"
})(["", ""], function (_ref3) {
  var twStyle = _ref3.twStyle;
  return twStyle || {};
});

var StyledButton = /*#__PURE__*/_styled.button.withConfig({
  displayName: "countries-menu__StyledButton",
  componentId: "sc-1239cyb-1"
})(["", " ", ""], {
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "columnGap": "0.25rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "textAlign": "left",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem"
}, function (_ref4) {
  var isLastFavorite = _ref4.isLastFavorite;
  return isLastFavorite ? {
    "borderBottomWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(229 231 235 / var(--tw-border-opacity))"
  } : {};
});

var StyledMenuItems = /*#__PURE__*/_styled(Menu.Items).withConfig({
  displayName: "countries-menu__StyledMenuItems",
  componentId: "sc-1239cyb-2"
})(["", " ", ""], selectOptionsStyle, {
  "width": "320px"
});

var StyledMenuItem = /*#__PURE__*/_styled.span.withConfig({
  displayName: "countries-menu__StyledMenuItem",
  componentId: "sc-1239cyb-3"
})(["", " ", " ", ""], selectOptionStyle, {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem"
}, function (_ref5) {
  var active = _ref5.active;
  return active ? {
    "display": "flex",
    "height": "3rem",
    "width": "100%",
    "alignItems": "center",
    "borderRadius": "0.5rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(235 235 237 / var(--tw-bg-opacity))"
  } : {};
});

var _StyledMenuButton = /*#__PURE__*/_styled(Menu.Button).withConfig({
  displayName: "countries-menu___StyledMenuButton",
  componentId: "sc-1239cyb-4"
})({
  "display": "inline-flex",
  "height": "2rem",
  "width": "fit-content",
  "alignItems": "center",
  "gap": "0.25rem",
  "borderRadius": "0.25rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))",
  "padding": "0.5rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))"
});